/* Titta · Combos — selector por prenda (solo stock), precio de combo y código oculto aplicado al agregar.
   Manu — Agencia de Performance Marketing y Publicidad Digital */
(function () {
  'use strict';

  function money(cents, fmt) {
    var s = Math.round(cents / 100).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    if (fmt && fmt.indexOf('{{') > -1) return fmt.replace(/\{\{\s*[a-z_]+\s*\}\}/, s).replace(/,00$/, '');
    return '$' + s;
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  var SIZE_RANK = ['XXS','XS','S','M','L','XL','XXL','2XL','XXXL','3XL'];
  function sizeRank(v) { var k = String(v).trim().toUpperCase().split(/[\s(\/]/)[0]; var i = SIZE_RANK.indexOf(k); return i < 0 ? 99 : i; }
  function sortSizes(vals) {
    if (!vals.every(function (v) { return sizeRank(v) < 99; })) return vals;
    return vals.slice().sort(function (a, b) { return sizeRank(a) - sizeRank(b); });
  }
  var COLOR_WORDS = ['color', 'colour', 'tono'];
  function isColorName(n) { n = String(n || '').toLowerCase(); return COLOR_WORDS.some(function (w) { return n.indexOf(w) > -1; }); }

  /* Nombre corto de un producto dentro de su grupo: quita el prefijo común ("Set Aria Chocolate" -> "Chocolate") */
  function shortNames(products) {
    var t = products.map(function (p) { return p.title.split(' '); });
    var k = 0;
    if (t.length > 1) {
      while (t.every(function (w) { return w.length > k + 1 && w[k].toLowerCase() === t[0][k].toLowerCase(); })) k++;
    }
    return t.map(function (w) { return w.slice(k).join(' ') || w.join(' '); });
  }

  function init(root) {
    if (root.dataset.tcInit) return; root.dataset.tcInit = '1';
    var sec = root.closest('.titta-pack') || document;
    var cfg = JSON.parse(root.querySelector('[data-combo-json]').textContent);
    var fmt = cfg.moneyFormat, hex = {};
    (cfg.colorHex || '').split(/\n/).forEach(function (l) { var i = l.lastIndexOf(':'); if (i > 0) hex[l.slice(0, i).trim().toLowerCase()] = l.slice(i + 1).trim(); });

    /* Unidades: una tarjeta por prenda (qty repetida) */
    var units = [], n = 0;
    cfg.slots.forEach(function (s, si) {
      s.products.forEach(function (p) { p.hasStock = p.variants.some(function (v) { return v.available; }); });
      s.short = shortNames(s.products);
      for (var u = 0; u < s.qty; u++) units.push({ si: si, u: u, n: ++n, p: -1, sel: [], touched: false });
    });

    function prod(un) { return cfg.slots[un.si].products[un.p]; }
    function match(v, sel, upto) { for (var k = 0; k < upto; k++) if (v.o[k] !== sel[k]) return false; return true; }
    function valuesFor(p, sel, i) {
      var out = [];
      p.variants.forEach(function (v) { if (v.available && match(v, sel, i) && out.indexOf(v.o[i]) < 0) out.push(v.o[i]); });
      return out;
    }
    function resolve(un) {
      var p = prod(un), N = p.options.length;
      for (var i = 0; i < N; i++) {
        var vals = valuesFor(p, un.sel, i);
        if (vals.length && vals.indexOf(un.sel[i]) < 0) un.sel[i] = vals[0];
      }
      un.v = p.variants.filter(function (v) { return v.available && match(v, un.sel, N); })[0] || null;
    }
    function imgFor(p, sel, i, val) {
      var k;
      for (k = 0; k < p.variants.length; k++) { var v = p.variants[k]; if (v.o[i] === val && v.img && match(v, sel, i)) return v.img; }
      for (k = 0; k < p.variants.length; k++) if (p.variants[k].o[i] === val && p.variants[k].img) return p.variants[k].img;
      return null;
    }

    /* Selección inicial: primer producto con stock; en prendas repetidas, colores distintos si hay */
    units.forEach(function (un) {
      var s = cfg.slots[un.si];
      var withStock = s.products.map(function (p, i) { return p.hasStock ? i : -1; }).filter(function (i) { return i > -1; });
      un.p = withStock.length ? withStock[Math.min(un.u, withStock.length - 1) % withStock.length] : 0;
      var p = prod(un);
      var first = p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
      un.sel = first.o.slice(0, p.options.length);
      var ci = p.options.map(isColorName).indexOf(true);
      if (ci > -1 && un.u > 0) {
        var colors = []; p.variants.forEach(function (v) { if (v.available && colors.indexOf(v.o[ci]) < 0) colors.push(v.o[ci]); });
        if (colors.length) un.sel[ci] = colors[un.u % colors.length];
      }
      resolve(un);
    });

    var box = root.querySelector('[data-combo-units]'), sumEl = root.querySelector('[data-combo-sum]'),
        btn = root.querySelector('[data-combo-add]'), lbl = root.querySelector('[data-combo-label]'),
        msgEl = root.querySelector('[data-combo-msg]'), baseLbl = (lbl.textContent.split('·')[0] || 'Agregar combo al carrito').trim();
    var elNow = sec.querySelector('[data-combo-now]'), elWas = sec.querySelector('[data-combo-was]'), elSave = sec.querySelector('[data-combo-save]'),
        stPrice = root.querySelector('[data-combo-sticky-price]');

    function msg(t, err) { if (!t) { msgEl.hidden = true; return; } msgEl.hidden = false; msgEl.textContent = t; msgEl.classList.toggle('is-error', !!err); }

    function btnEl(cls, label, checked, title) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = cls; b.setAttribute('role', 'radio'); b.setAttribute('aria-checked', checked ? 'true' : 'false');
      if (title) { b.title = title; b.setAttribute('aria-label', title); }
      if (label != null) b.textContent = label;
      return b;
    }

    function renderUnit(un) {
      var s = cfg.slots[un.si], p = prod(un);
      var card = document.createElement('div');
      card.className = 'titta-cu' + (un.v ? '' : ' is-out');
      var thumb = (un.v && un.v.img) || p.img;
      var name = s.label + (s.qty > 1 ? ' ' + (un.u + 1) : '');
      var chosen = [s.products.length > 1 ? s.short[un.p] : null].concat(un.sel).filter(Boolean).join(' · ');
      card.innerHTML =
        '<div class="titta-cu__head">' +
          '<span class="titta-cu__thumb"' + (thumb ? ' style="background-image:url(\'' + esc(thumb) + '\')"' : '') + '></span>' +
          '<span class="titta-cu__meta"><b class="titta-cu__name"><span class="titta-cu__n">' + un.n + '</span>' + esc(name) +
            (s.gift ? ' <em class="titta-cu__gift">De regalo</em>' : '') + '</b>' +
            '<small class="titta-cu__chosen">' + esc(chosen) + '</small></span>' +
        '</div>';

      /* Color como producto (grupos de productos por color) */
      if (s.products.length > 1) {
        var row = document.createElement('div'); row.className = 'titta-cu__row';
        row.innerHTML = '<span class="titta-cu__lab">Color</span>';
        var vals = document.createElement('div'); vals.className = 'titta-cu__vals is-swatch';
        s.products.forEach(function (pp, pi) {
          if (!pp.hasStock) return;
          var b = btnEl('titta-color titta-cu__sw' + (pi === un.p ? ' is-picked' : ''), null, pi === un.p, s.short[pi]);
          if (pp.img) b.style.backgroundImage = 'url("' + pp.img + '")';
          b.addEventListener('click', function () {
            var keep = un.sel.slice(); un.p = pi; var np = prod(un);
            un.sel = np.options.map(function (_, k) { return keep[k]; }); un.touched = true;
            resolve(un); render();
          });
          vals.appendChild(b);
        });
        row.appendChild(vals); card.appendChild(row);
      }

      /* Opciones del producto (tallas, tanga/panty, color) */
      p.options.forEach(function (oname, i) {
        var vs = isColorName(oname) ? valuesFor(p, un.sel, i) : sortSizes(valuesFor(p, un.sel, i));
        if (vs.length <= 1 && p.options.length === 1 && vs[0] === 'Default Title') return;
        var row = document.createElement('div'); row.className = 'titta-cu__row';
        row.innerHTML = '<span class="titta-cu__lab">' + esc(String(oname).trim()) + '</span>';
        var wrap = document.createElement('div'), col = isColorName(oname);
        /* Si algún valor de color no tiene foto ni color de respaldo, se muestran todos como texto (evita palabras cortadas) */
        if (col && !vs.every(function (val) { return imgFor(p, un.sel, i, val) || hex[String(val).toLowerCase()]; })) col = false;
        wrap.className = 'titta-cu__vals' + (col ? ' is-swatch' : '');
        vs.forEach(function (val) {
          var on = val === un.sel[i], b;
          if (col) {
            var im = imgFor(p, un.sel, i, val), hx = hex[String(val).toLowerCase()];
            if (im || hx) {
              b = btnEl('titta-color titta-cu__sw' + (on ? ' is-picked' : ''), null, on, val);
              if (im) b.style.backgroundImage = 'url("' + im + '")'; else b.style.backgroundColor = hx;
            } else b = btnEl('titta-size', val, on, val);
          } else b = btnEl('titta-size', val, on, val);
          b.addEventListener('click', function () {
            un.sel[i] = val; un.touched = true; resolve(un);
            /* Conveniencia: la talla elegida en la 1ª prenda se copia a las demás del mismo tipo que no se han tocado */
            if (!col && un.u === 0) units.forEach(function (o) {
              if (o !== un && o.si === un.si && !o.touched && o.p === un.p) {
                if (valuesFor(prod(o), o.sel, i).indexOf(val) > -1) { o.sel[i] = val; resolve(o); }
              }
            });
            render();
          });
          wrap.appendChild(b);
        });
        if (!vs.length) wrap.innerHTML = '<span class="titta-cu__none">Sin stock en esta combinación</span>';
        row.appendChild(wrap); card.appendChild(row);
      });

      if (un.v && un.v.stock > 0 && un.v.stock <= 3) {
        var low = document.createElement('p'); low.className = 'titta-cu__low';
        low.innerHTML = '🔥 ¡Quedan solo <strong>' + un.v.stock + '</strong>!';
        card.appendChild(low);
      }
      return card;
    }

    function totals() {
      var sum = 0, ok = true;
      units.forEach(function (un) { if (un.v) sum += un.v.price; else ok = false; });
      return { sum: sum, now: Math.max(0, sum - cfg.off), ok: ok };
    }

    function render() {
      var open = box.querySelector('.titta-cu') ? null : null;
      box.innerHTML = '';
      units.forEach(function (un) { box.appendChild(renderUnit(un)); });
      var t = totals();
      var pct = t.sum ? Math.round(cfg.off * 100 / t.sum) : 0;
      sumEl.innerHTML =
        '<div class="titta-combo__line"><span>Precio normal</span><s>' + money(t.sum, fmt) + '</s></div>' +
        '<div class="titta-combo__line is-save"><span>Descuento combo</span><b>−' + money(cfg.off, fmt) + '</b></div>' +
        '<div class="titta-combo__line is-ship"><span>Envío</span><b>Gratis</b></div>' +
        '<div class="titta-combo__line is-total"><span>Total combo</span><b>' + money(t.now, fmt) + '</b></div>';
      if (elNow) elNow.textContent = money(t.now, fmt);
      if (elWas) elWas.textContent = money(t.sum, fmt);
      if (elSave) elSave.textContent = 'Ahorras ' + money(cfg.off, fmt) + ' (' + pct + '%)';
      if (stPrice) stPrice.textContent = money(t.now, fmt);
      btn.disabled = !t.ok;
      lbl.textContent = t.ok ? baseLbl + ' · ' + money(t.now, fmt) : 'Elige una combinación con stock';
      var addi = document.querySelector('addi-product-widget'); if (addi) addi.setAttribute('price', String(t.now / 100));
    }

    btn.addEventListener('click', function () {
      var t = totals(); if (!t.ok) return;
      var agg = {};
      units.forEach(function (un) { agg[un.v.id] = (agg[un.v.id] || 0) + 1; });
      var items = Object.keys(agg).map(function (id) { return { id: +id, quantity: agg[id], properties: { _combo: cfg.title } }; });
      var root_ = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var H = { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' };
      btn.classList.add('is-loading'); lbl.textContent = 'Agregando combo…'; msg('');
      fetch(root_ + 'cart/add.js', { method: 'POST', headers: H, body: JSON.stringify({ items: items }) })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.d.description || res.d.message || 'No pudimos agregar el combo.');
          var added = res.d.items ? res.d.items[0] : res.d;
          if (!cfg.code) return added;
          /* Aplica el código y confirma que quedó en el carrito (otras apps pueden pisarlo); reintenta hasta 4 veces */
          var tries = 0;
          function apply() {
            tries++;
            return fetch(root_ + 'cart/update.js', { method: 'POST', headers: H, body: JSON.stringify({ discount: cfg.code }) })
              .then(function () { return new Promise(function (r) { setTimeout(r, 700); }); })
              .then(function () { return fetch(root_ + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); })
              .then(function (c) {
                var ok = (c.discount_codes || []).some(function (d) { return String(d.code).toUpperCase() === cfg.code.toUpperCase() && d.applicable; });
                if (!ok && tries < 4) return apply();
                return added;
              })
              .catch(function () { if (tries < 4) return apply(); return added; });
          }
          return apply();
        })
        .then(function (added) {
          btn.classList.remove('is-loading'); lbl.textContent = '¡Combo agregado!';
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true, detail: { product: added, addToCartBtn: btn } }));
          if (window.theme && theme.settings && theme.settings.cartType === 'page') location.href = root_ + 'cart';
          setTimeout(render, 2200);
        })
        .catch(function (e) { btn.classList.remove('is-loading'); msg(e.message || 'Error de conexión. Intenta de nuevo.', true); render(); });
    });

    var sticky = root.querySelector('[data-sticky]'), sBtn = root.querySelector('[data-sticky-btn]');
    if (sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        var e = en[0], show = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show); sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      }).observe(btn);
      sBtn.addEventListener('click', function () { btn.click(); });
    }
    var dlg = root.querySelector('[data-size-dialog]'), op = root.querySelector('[data-size-open]'), cl = root.querySelector('[data-size-close]');
    if (dlg && op) {
      op.addEventListener('click', function () { dlg.showModal ? dlg.showModal() : dlg.setAttribute('open', ''); });
      cl.addEventListener('click', function () { dlg.close ? dlg.close() : dlg.removeAttribute('open'); });
      dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    }
    render();
  }

  function boot(scope) { (scope || document).querySelectorAll('[data-combo]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); }); else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
